"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NameHover = exports.MainContainer = exports.Image = exports.CounterExtra = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var MainContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  position: relative;\n  width: 100%;\n  height: 100%;\n"])));

exports.MainContainer = MainContainer;

var Image = _styledComponents.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  z-index: ", ";\n  left: ", ";\n  .img {\n    width: 18px;\n    height: 18px;\n    object-fit: fill;\n    border-radius: 100%;\n  }\n"])), function (_ref) {
  var index = _ref.index;
  return 5 - index;
}, function (_ref2) {
  var index = _ref2.index;
  return "".concat(11 * index, "px");
});

exports.Image = Image;

var NameHover = _styledComponents.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  white-space: nowrap;\n  z-index: 20;\n  position: absolute;\n  left: ", "px;\n  top: -7px;\n  font-family: Roboto;\n  font-size: 10px;\n  background: #ffffff;\n  border-radius: 3px;\n  box-shadow: 0px 2px 4px #00000029;\n  padding: 2px 5px;\n"])), function (_ref3) {
  var index = _ref3.index;
  return 9;
});

exports.NameHover = NameHover;

var CounterExtra = _styledComponents.default.div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n  background: #8a6caaaa;\n  color: #ffffff;\n  border-radius: 50%;\n  width: 18px;\n  height: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 5px;\n"])));

exports.CounterExtra = CounterExtra;